import React from "react";
//import RcTree from 'rc-tree';
// import RcTree from "../../_rc-tree-1.3.10/src";
import TreeZ from "../tree-z";
// import RcTree from '../../_rc-tree-1.13.2/src';
import animation from "../_util/openAnimation";
import Loadable from "../../react-loadable";
const RcTree = Loadable({
  loader: () => import("../../_rc-tree-1.3.10/src"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
import TreeNode from "../../_rc-tree-1.3.10/src/TreeNode";
export default class Tree extends React.Component {
  // static TreeNode = RcTree.TreeNode;
  static TreeNode = TreeNode;
  static defaultProps = {
    prefixCls: "ant-tree",
    checkable: false,
    showIcon: false,
    openAnimation: animation
  };

  render() {
    const props = this.props;
    let checkable = props.checkable;
    if (checkable) {
      checkable = <span className={`${props.prefixCls}-checkbox-inner`} />;
    }
    let treeInstance;
    if (props.ztreeMode) {
      treeInstance = <TreeZ {...props} ecId={`${props.ecId}_TreeZ@xhaqqt`} />;
    } else {
      treeInstance = (
        <RcTree
          {...props}
          ecId={`${props.ecId}_RcTree@pybwdr`}
          checkable={checkable}
          ref="rcTree"
        >
          {this.props.children}
        </RcTree>
      );
    }
    return treeInstance;
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/tree/index.jsx